import { render, staticRenderFns } from "./Updates.vue?vue&type=template&id=a296c268&scoped=true"
import script from "./Updates.vue?vue&type=script&lang=js"
export * from "./Updates.vue?vue&type=script&lang=js"
import style0 from "./Updates.vue?vue&type=style&index=0&id=a296c268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a296c268",
  null
  
)

export default component.exports